import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import SearchPage from "./pages/Search";
import ListingDetail from "./pages/ListingDetail";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import ForProviders from "./pages/ForProviders";
import ForAgencies from "./pages/ForAgencies";
import About from "./pages/About";
import KessServiceCenter from "./pages/KessServiceCenter";
import ProviderApplication from "./pages/ProviderApplication";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/listings/:id" element={<ListingDetail />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/for-providers" element={<ForProviders />} />
            <Route path="/for-agencies" element={<ForAgencies />} />
            <Route path="/about" element={<About />} />
            <Route path="/kess" element={<KessServiceCenter />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/provider/application" element={<Protected><ProviderApplication /></Protected>} />
            <Route path="/payment-success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
